import axios from "axios";
import { useEffect, useState } from "react";
import { Loader2, Mail, Send } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function EmailReportButton({ month, onSent }) {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [company, setCompany] = useState("");
  const [busy, setBusy] = useState(false);
  const [notice, setNotice] = useState({ text: "", error: false });

  useEffect(() => {
    if (!open) return;
    axios.get(`${API}/settings`).then(r => { setEmail(r.data.accountant_email || ""); setCompany(r.data.company_name || ""); }).catch(() => {});
    setNotice({ text: "", error: false });
  }, [open]);

  const send = async event => {
    event.preventDefault();
    setBusy(true);
    try {
      await axios.put(`${API}/settings`, { accountant_email: email, company_name: company || null });
      const { data } = await axios.post(`${API}/reports/monthly-pdf/email`, { month });
      setNotice({ text: `Rapor gönderildi → ${data.to}`, error: false });
      onSent?.();
    } catch (e) {
      setNotice({ text: e?.response?.data?.detail || "Gönderim başarısız", error: true });
    } finally {
      setBusy(false);
    }
  };

  const monthLabel = new Date(`${month}-01`).toLocaleDateString("tr-TR", { month: "long", year: "numeric" });

  return (
    <>
      <button className="outline-btn" data-testid="email-report-button" onClick={() => setOpen(true)}><Mail size={16}/> Muhasebeciye gönder</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="edit-dialog" data-testid="email-report-dialog">
          <DialogHeader>
            <DialogTitle>{monthLabel} raporunu e-posta ile gönder</DialogTitle>
            <DialogDescription>Özet tablo e-posta gövdesinde, tam rapor PDF eki olarak gider. Adres kaydedilir; bir sonraki ay tek tık yeter.</DialogDescription>
          </DialogHeader>
          <form onSubmit={send} className="edit-form">
            <div className="field">
              <label>Muhasebeci e-posta adresi</label>
              <input data-testid="accountant-email-input" required type="email" placeholder="muhasebe@ornek.com" value={email} onChange={e => setEmail(e.target.value)}/>
            </div>
            <div className="field">
              <label>Şirket adı <small className="hint">(e-posta başlığında görünür)</small></label>
              <input data-testid="company-name-input" placeholder="Şirketiniz" value={company} onChange={e => setCompany(e.target.value)}/>
            </div>
            <div className="dialog-actions">
              <button type="button" className="outline-btn" data-testid="email-cancel-button" onClick={() => setOpen(false)}>Kapat</button>
              <button type="submit" className="primary-btn" data-testid="email-send-button" disabled={busy}>
                {busy ? <Loader2 size={16} className="spin"/> : <Send size={16}/>} Gönder
              </button>
            </div>
            {notice.text && <div className={`notice ${notice.error ? "error" : ""}`} data-testid="email-notice">{notice.text}</div>}
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}
